<template>
  <div @touchstart="handleTouch" @touchend="handleTouch">
    <div class="numbarea" v-if="!disableNumbArea"></div>
    <a v-for="char in chars.split(',')" :data-char="char"><a>{{ char }}</a></a>
  </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/mixins';

  div {
    display: flex;

    .numbarea {
      position: absolute;
      top: -80px;
      height:60px;
      width: 100%;
      background-color: transparent;

      @media (max-width: #{$small-phone-width}) {
        display: none;
      }
    }

    a {
      position: relative;
      flex: 1;
      font-family: Roboto, Helvetica, sans-serif;
      font-size: 1.25rem;
      height: 58px;

      &:before {
        position: absolute;
        top: -20px;
        right: 0;
        left: 0;
        bottom: 0;
        content: '';
        display: block;
        height: 20px;
      }

      a {
        @include ios-button;
        display: block;
        margin: 7px 2.5px;
        line-height: 44px;
        height: 44px;
      }
    }
  }
</style>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'

  export default Vue.component('char-keyboard', {
    props: {
      chars: {
        type: String,
        default: ''
      },
      disableNumbArea: {
        type: Boolean,
        default: false
      },
      directInput: {
        type: Boolean,
        default: false
      }
    },
    computed: mapState(['app']),
    data () {
      return {
        touchstart: null
      }
    },
    methods: {
      programInput (input, entryValue) {
        if (input.selectionStart !== '0') {
          let startPos = input.selectionStart
          let endPos = input.selectionEnd
          let beforeEntry = input.value && input.value.substring(0, startPos)
          let afterEntry = input.value && input.value.substring(endPos, input.value.length)
          input.value = beforeEntry + entryValue + afterEntry
          // Set cursor after newly inserted character
          let beforeCursor = beforeEntry + entryValue
          input.setSelectionRange && input.setSelectionRange(beforeCursor.length, beforeCursor.length)
        } else {
          input.value += entryValue
        }
        // Trigger input event
        let inputEvent = new Event('input')
        input.dispatchEvent(inputEvent)
      },
      handleTouch (e) {
        if (e.type === 'touchstart' && e.touches.length === 1) {
          this.touchstart = {
            timeStamp: e.timeStamp,
            pageX: e.pageX,
            pageY: e.pageY,
            target: e.target
          }
        }

        if (e.type === 'touchend') {
          let touchend = {
            timeStamp: e.timeStamp - this.touchstart.timeStamp,
            pageX: e.pageX - this.touchstart.pageX,
            pageY: e.pageY - this.touchstart.pageY,
            target: e.target,
            sameTarget: e.target === this.touchstart.target
          }

          this.touchstart = null

          if (touchend.target.className.toLowerCase() === 'numbarea') {
            const keyboardEvent = new window.KeyboardEvent('keydown', {
              key: 'alt'
            })

            delete keyboardEvent.keyCode
            Object.defineProperty(keyboardEvent, 'keyCode', { value: 18 })

            e.preventDefault()
            e.stopImmediatePropagation()
            document.activeElement.dispatchEvent(keyboardEvent)
          }

          if (touchend.timeStamp < 500 && touchend.target.nodeName.toLowerCase() === 'a' && this.$el.contains(touchend.target)) {
            e.preventDefault()
            e.stopImmediatePropagation()
            const key = touchend.target.innerText || touchend.target.firstElementChild.innerText
            if (key === '···') {
              document.activeElement.blur()
              this.$store.dispatch('updateApp', {
                keyboardType: 'alphanumeric'
              })
            }
            if (this.directInput) {
              return this.programInput(document.activeElement, key)
            }
            const keyCode = key.charCodeAt(0)
            const keyboardEvent = new window.KeyboardEvent('keypress', {
              key: key,
              char: key
            })

            delete keyboardEvent.keyCode
            Object.defineProperty(keyboardEvent, 'keyCode', { value: keyCode })

            document.activeElement.dispatchEvent(keyboardEvent)
          }
        }
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/CharKeyboard.vue